import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";

export interface GetConsentForCandidateResponse extends BackendResponse {
  items: Consent[];
}

export const getConsentForCandidate =
  withNextApi<GetConsentForCandidateResponse>(
    "/cvp/CvpGetConsentForCandidate",
    { method: "GET" }
  );
  
export interface Consent {
  id: number;
  consentName: string;
  consentType: number;
  fromDate?: Date;
  toDate?: Date;
  active: boolean;
  idRelated: number;
  typeRelated: number;
  name: string;
  extra: string;
  content: string;
}